<template>
    <div :class="withPadding ? 'py-2' : ''">
        <strong>Razão Social: </strong>{{ client.legal_name }} <br>
        <strong>Nome Fantasia: </strong>{{ client.trade_name }} <br>
        <strong>ID da Loja: </strong>{{ client.store_id }} <br>
        <strong>ID do Hubspot: </strong>{{ client.hubspot_id }} <br>

        <strong v-if="isCpfFormatted(client.document)">CPF: </strong>
        <strong v-else>CNPJ: </strong>
        {{ client.document }} <br>
    </div>
</template>

<script>
import documentMixin from '@core/mixins/document'

export default {
    mixins: [
        documentMixin,
    ],
    props: {
        client: {
            type: Object,
            required: true,
        },
        withPadding: {
            type: Boolean,
            default: true
        }
    },
}
</script>